import type { MediaInfoResult } from 'mediainfo.js';

import type { FilesComponentSchema } from '@iconik-io/iconik-api/src/services/files';

export function parseMetadataToComponents(
  metadata: MediaInfoResult,
): FilesComponentSchema[] | undefined {
  if (!metadata?.media?.track) {
    return undefined;
  }

  return metadata.media.track
    .map<FilesComponentSchema | undefined>((track) => {
      const { '@type': type, ...rest } = track;
      const uppercaseType = track['@type'].toUpperCase();
      if (
        uppercaseType !== 'VIDEO' &&
        uppercaseType !== 'AUDIO' &&
        uppercaseType !== 'IMAGE' &&
        uppercaseType !== 'TEXT' &&
        uppercaseType !== 'OTHER' &&
        uppercaseType !== 'NON_MEDIA' &&
        uppercaseType !== 'EXIF' &&
        uppercaseType !== 'IPTC' &&
        uppercaseType !== 'XMP' &&
        uppercaseType !== 'GENERAL'
      ) {
        return undefined;
      }

      // Convert all metadata values to strings
      const stringMetadata: { [key: string]: string } = {};
      for (const [key, value] of Object.entries(rest)) {
        if (typeof value === 'object') {
          continue;
        }
        stringMetadata[key] = String(value);
      }

      return {
        metadata: stringMetadata,
        name: uppercaseType,
        type: uppercaseType,
      };
    })
    .filter(
      (component): component is FilesComponentSchema => component !== undefined,
    );
}
